/* eslint-disable no-useless-computed-key */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
} from "reactstrap";
import { Link } from "react-router-dom";
// import { IoIosSearch } from "react-icons/io";
import { MdSearch } from "react-icons/md";

import { MdLocationOn } from "react-icons/md";
import "../../pages/MyRoutes/myroutes.scss";
import { useDispatch, useSelector } from "react-redux";
import { showLoader, showPointList } from "../../utils/action/Action";
import { toast } from "react-toastify";
import ViewportList from "react-viewport-list";
import useDebounce from "../Debounce/Debounce";
import { getSearchEverywhere } from "../../services/search.service";

function PointsListingModal({
  showListModal,
  nameOfPoint,
  wizardData,
  setWizardData,
  setShowListModal,
  setPointName,
  pointName,
}) {
  const [searchText, setSearchText] = useState("");
  const [debouceValue, setDebouceValue] = useState("");
  const [searchedData, setSearchedData] = useState([]);
  const dispatch = useDispatch();
  const debounce = useDebounce();
  const ref = useRef(null);

  console.log("nameOfPoint", nameOfPoint);

  var regex =
    /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

  const startPoint = useSelector(
    (state) => state?.pointListReducer?.pointListData,
  );
  const userName = useSelector(
    (state) => state?.userDetailReducer?.userData?.userName,
  );

  const toggleList = () => {
    setShowListModal(!showListModal);
    setSearchText("");
    setSearchedData([]);
    setDebouceValue("");
    setPointName({
      id: "",
      title: "",
      cityY: "",
    });
    wizardData?.startingPoint &&
      setWizardData({
        ...wizardData,
        startingPoint: "",
      });
    wizardData?.endingPoint &&
      setWizardData({
        ...wizardData,
        endingPoint: "",
      });
  };

  useEffect(() => {
    if (showListModal === true) {
      fetchPointList();
    }
  }, [showListModal]);

  useEffect(() => {
    const fetchSearch = async () => {
      if (searchText?.length > 2 && debouceValue) {
        let obj = {
          filter: searchText.trim(),
          email: userName,
          checkForFavorite: true,
        };

        try {
          const res = await getSearchEverywhere(obj);

          if (res?.status === 200) {
            let searchData = [];

            Object.entries(res?.data?.data)?.forEach((item) => {
              searchData = searchData.concat(item[1]);
            });

            setSearchedData(searchData);

            if (searchData?.length === 0) {
              toast.error("No Records Found.", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000,
              });
            }
          }
        } catch (err) {
          console.log("Search Error:", err);
        }
      } else {
        setSearchedData([]);
      }
    };

    fetchSearch();
  }, [debouceValue]);

  const handleChange = (item) => {
    const itemId = item?.tzadikimID || item?.id || item?.mkmID;
    const itemTitle = item?.title || item?.mkmTitle;

    console.log("Selected Item:", item);
    console.log("Selected ID:", itemId);
    // console.log("Selected mkmID:", item?.mkmID);
    // console.log("Selected Title:", itemTitle);

    if (nameOfPoint?.name === "endingPoint") {
      setWizardData({
        ...wizardData,
        endingPoint: itemTitle,
      });

      setPointName({ id: itemId });
    } else if (nameOfPoint?.name === "startingPoint") {
      setWizardData({
        ...wizardData,
        startingPoint: itemTitle,
      });

      setPointName({ id: itemId });
    } else {
      setPointName({

        id: itemId,
        title: itemTitle,
        cityY: item?.cityY || item?.mkmCityY,
      });
    }
  };

  const fetchPointList = async () => {
    dispatch(showLoader());
    try {
      await dispatch(showPointList());
    } catch (error) {
      toast.error(
        error?.startPoint?.message ||
        "Oops.. something went wrong, try again !!!",
        {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        },
      );
    }
  };

  const handleSearch = (e) => {
    const newData = e?.target?.value?.replace(/^\s+/, "").replace(regex, "");
    if (newData?.length > 2) {
      debounce(() => setDebouceValue(newData));
      setSearchText(newData);
    } else {
      setSearchText(newData);
      setSearchedData([]);
      setDebouceValue("");
    }
  };
  const savePoint = () => {
    setShowListModal(false);
    setSearchText("");
    setSearchedData([]);
    setDebouceValue("");
  };

  console.log("Start Point : ", startPoint);
  // console.log("Searc Point : ", searchedData);
  console.log("Point name: ", pointName?.id);
  const listData = searchText?.length > 2 ? searchedData : startPoint;
  return (
    <Modal
      className="points_listing modal-dialog-centered"
      isOpen={showListModal}
    // toggle={toggleList}
    >
      <ModalHeader close={false}>
        <div>
          <div className="search_input">
            <div>
              <MdSearch className="search_icon" />
            </div>
            <input
              id="search"
              name="search"
              placeholder="Where are you going ?"
              value={searchText}
              onChange={(e) => handleSearch(e)}
              maxLength="100"
              autoComplete="off"
            />
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="grid" ref={ref}>
          {" "}
          <ViewportList
            key={listData?.length}
            viewportRef={ref}
            items={listData}
            itemMinSize={140}
            margin={8}
          >
            {(item) => {
              const itemId = item?.tzadikimID || item?.id || item?.mkmID;



              return (
                <Row key={item?.tzadikimID || item?.id || item?.mkmID}>
                  <Col>
                    <div
                      className="custom-card"
                      style={
                        !pointName?.id
                          ? {
                            border: "1px solid transparent",
                            borderRadius: "10px",
                            boxShadow: "0px 0px 30px 0px #0000001a",
                          }
                          : pointName.id === itemId
                            ? {
                              background: `linear-gradient(0deg, #FFFFFF, #FF680008)`,
                              border: "1px solid #ff8028",
                              borderRadius: "10px",
                              boxShadow: "0px 0px 30px 0px #0000001a",
                            }
                            : {
                              border: "1px solid #ffffff",
                              borderRadius: "10px",
                              boxShadow: "0px 0px 30px 0px #0000001a",
                            }
                      }
                    >
                      <div className="card-body-left_side">
                        <Form className="form">
                          <FormGroup check>
                            <Label check>
                              <Input
                                type="radio"
                                name="pointSelect"
                                checked={pointName?.id === itemId}
                                onChange={() => handleChange(item)}
                                value={
                                  itemId?.title
                                    ? itemId?.title
                                    : itemId?.mkmTitle
                                }
                              />
                            </Label>
                          </FormGroup>
                        </Form>
                      </div>

                      <div className="card-body-right_side">
                        <div className="nt-card_header">
                          <h5>{item?.title ? item?.title : item?.mkmTitle}</h5>
                          <p>
                            {item?.cityY} {item?.stateY}
                          </p>
                        </div>

                        <div className="card_bottom">
                          <div className="location">
                            {item?.cityE + " " + item?.stateE}
                          </div>
                          <Link to="#" className="location_icon">
                            <MdLocationOn size={18} />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              );
            }}
          </ViewportList>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            toggleList();
          }}
          className="btn cancel"
        >
          Cancel
        </Button>
        <Button className="btn save" onClick={savePoint}>
          Save Point
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default PointsListingModal;
